// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-layers-panel-wrapper {
  position: absolute;
  top: var(--map-panel-offset-top, 16px);
  right: var(--map-panel-offset-right, 16px);
  z-index: 1200;
  width: 360px;
  max-width: calc(100vw - 32px);
}

.layers-panel-card {
  margin: 0;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.16);
  max-height: 75vh;
  display: flex;
  flex-direction: column;
}

.layers-panel-header {
  padding-bottom: 8px;
  flex: 0 0 auto;
}

.layers-panel-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.layers-panel-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  min-height: 0;
  max-height: calc(75vh - 90px);
  padding-bottom: 8px;
}
.layers-panel-content::-webkit-scrollbar {
  width: 8px;
}
.layers-panel-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

.secondary-actions-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 0 auto;
}

.group-section {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  flex: 0 0 auto;
}

.group-title-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.03);
}

.group-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: transparent;
}

.collapsible-title {
  border: 0;
  cursor: pointer;
}

.with-action {
  flex: 1;
  min-width: 0;
}

.group-action-button {
  align-self: center;
  white-space: nowrap;
}

.group-title-left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.group-body {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 220px;
  overflow-y: auto;
}
.group-body::-webkit-scrollbar {
  width: 6px;
}
.group-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.16);
  border-radius: 8px;
}

.base-group-body {
  max-height: 180px;
  overflow-y: auto;
}

.base-layer-item {
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 44px;
  padding: 6px 4px;
  cursor: pointer;
  text-align: left;
}

.base-layer-left {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.base-layer-radio {
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 50%;
  border: 2px solid var(--ion-color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.base-layer-radio.selected {
  border-color: var(--ion-color-primary);
}

.base-layer-radio-inner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ion-color-primary);
}

.overlay-layer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 44px;
}

.layer-label-block {
  flex: 1;
  min-width: 0;
}

.layer-label {
  display: inline-block;
  font-size: 14px;
  line-height: 1.3;
}

@media (max-width: 1023px) {
  .custom-layers-panel-wrapper {
    top: auto;
    right: 12px;
    left: 12px;
    bottom: 12px;
    width: auto;
    max-width: none;
  }
  .layers-panel-card {
    max-height: 60vh;
  }
  .layers-panel-content {
    max-height: calc(60vh - 90px);
  }
  .group-body {
    max-height: 160px;
  }
  .base-group-body {
    max-height: 140px;
  }
  .group-title-row {
    flex-direction: column;
  }
  .group-action-button {
    align-self: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/leaflet-map/components/map-layers-panel/map-layers-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sCAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;AACF;;AAEA;EACE,SAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,+BAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,cAAA;AADF;;AAIA;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AADF;AAGE;EACE,UAAA;AADJ;AAIE;EACE,+BAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,sCAAA;AAHF;;AAMA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAHF;;AAMA;EACE,OAAA;EACA,YAAA;AAHF;;AAMA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE;IACE,SAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;EAHF;EAMA;IACE,gBAAA;EAJF;EAOA;IACE,6BAAA;EALF;EAQA;IACE,iBAAA;EANF;EASA;IACE,iBAAA;EAPF;EAUA;IACE,sBAAA;EARF;EAWA;IACE,mBAAA;EATF;AACF","sourcesContent":[".custom-layers-panel-wrapper {\r\n  position: absolute;\r\n  top: var(--map-panel-offset-top, 16px);\r\n  right: var(--map-panel-offset-right, 16px);\r\n  z-index: 1200;\r\n  width: 360px;\r\n  max-width: calc(100vw - 32px);\r\n}\r\n\r\n.layers-panel-card {\r\n  margin: 0;\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.16);\r\n  max-height: 75vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.layers-panel-header {\r\n  padding-bottom: 8px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.layers-panel-title-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.layers-panel-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  overflow-y: auto;\r\n  min-height: 0;\r\n  max-height: calc(75vh - 90px);\r\n  padding-bottom: 8px;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 8px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.18);\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n.secondary-actions-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.group-section {\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.group-title-row {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 8px;\r\n  padding: 8px;\r\n  background: rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.group-title {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 12px 14px;\r\n  background: transparent;\r\n}\r\n\r\n.collapsible-title {\r\n  border: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.with-action {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.group-action-button {\r\n  align-self: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.group-title-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n.group-body {\r\n  padding: 8px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.16);\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n.base-group-body {\r\n  max-height: 180px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.base-layer-item {\r\n  width: 100%;\r\n  border: 0;\r\n  background: transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  min-height: 44px;\r\n  padding: 6px 4px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.base-layer-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n}\r\n\r\n.base-layer-radio {\r\n  width: 18px;\r\n  height: 18px;\r\n  min-width: 18px;\r\n  border-radius: 50%;\r\n  border: 2px solid var(--ion-color-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.base-layer-radio.selected {\r\n  border-color: var(--ion-color-primary);\r\n}\r\n\r\n.base-layer-radio-inner {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--ion-color-primary);\r\n}\r\n\r\n.overlay-layer-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  min-height: 44px;\r\n}\r\n\r\n.layer-label-block {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.layer-label {\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  line-height: 1.3;\r\n}\r\n\r\n@media (max-width: 1023px) {\r\n  .custom-layers-panel-wrapper {\r\n    top: auto;\r\n    right: 12px;\r\n    left: 12px;\r\n    bottom: 12px;\r\n    width: auto;\r\n    max-width: none;\r\n  }\r\n\r\n  .layers-panel-card {\r\n    max-height: 60vh;\r\n  }\r\n\r\n  .layers-panel-content {\r\n    max-height: calc(60vh - 90px);\r\n  }\r\n\r\n  .group-body {\r\n    max-height: 160px;\r\n  }\r\n\r\n  .base-group-body {\r\n    max-height: 140px;\r\n  }\r\n\r\n  .group-title-row {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .group-action-button {\r\n    align-self: stretch;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
